'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { objectToQueryString, queryStringToObject } from '@lib/url/queryUtils';
import { Button } from '../../../../../Clickables/Buttons/Button';
import { IInternalLinkProps } from '../../../../../Clickables/InternalLink/InternalLink';

const SuspendedCreatePostButton = ({
  onClick,
  buttonSize,
  className,
}: {
  onClick: () => void;
  buttonSize: IInternalLinkProps['size'];
  className?: string;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();

  const openCreatePostModal = (): void => {
    const search = queryStringToObject(searchParams.toString());
    const url = `${pathname}?${objectToQueryString({ ...search, add_post: 'show' })}`;
    router.replace(url);
    onClick();
  };

  return (
    <Button
      size={buttonSize}
      variant="buttonPrimary"
      className={className}
      onClick={() => {
        openCreatePostModal();
      }}
    >
      Add post
    </Button>
  );
};

export const CreatePostButton = ({
  buttonSize = 'default',
  className,
  onClick,
}: {
  buttonSize?: IInternalLinkProps['size'];
  className?: string;
  onClick?: () => void;
}) => {
  const { currentPage } = useAnalytics();
  return (
    <Suspense>
      <SuspendedCreatePostButton
        buttonSize={buttonSize}
        className={className}
        onClick={() => {
          trackEvent({
            name: 'mykiss_hamburger_clicked',
            properties: { action: 'navigate', source: currentPage },
          });
          if (onClick) {
            onClick();
          }
        }}
      />
    </Suspense>
  );
};
